import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  IconButton,
  Tooltip,
  CircularProgress,
} from '@mui/material'
import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined'
import AddIcon from '@mui/icons-material/Add'

const CATEGORY_LABELS = {
  new_feature: 'Uusi ominaisuus',
  change_existing: 'Muutos olemassaolevaan',
}

const SUBCATEGORY_LABELS = {
  booking: 'Varaukset',
  payments: 'Maksut',
  reporting: 'Raportointi',
  customers: 'Asiakkaat',
  resources: 'Resurssit',
  activities: 'Aktiviteetit',
  communication: 'Viestintä',
  settings: 'Asetukset',
  other: 'Muu',
}

const STATE_COLORS = {
  approved: 'primary',
  planned: 'info',
  implemented: 'success',
}

function FeatureRequestCard({ request, userVotes, remainingVotes, onVote, isVoting }) {
  const currentVotes = userVotes || 0
  const hasVoted = currentVotes > 0
  const votingDisabled = request.state === 'planned' || request.state === 'implemented'

  const handleAddVote = () => {
    if (remainingVotes > 0 && currentVotes < 3 && !isVoting && !votingDisabled) {
      onVote(request.id, 1)
    }
  }

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box flex={1}>
            <Typography variant="h6" component="div" gutterBottom>
              {request.title}
            </Typography>
            <Box mb={1}>
              <Chip
                label={CATEGORY_LABELS[request.category] || request.category}
                size="small"
                sx={{ mr: 1 }}
              />
              <Chip
                label={SUBCATEGORY_LABELS[request.subcategory] || request.subcategory}
                size="small"
                variant="outlined"
                sx={{ mr: 1 }}
              />
              {request.state !== 'approved' && (
                <Chip
                  label={request.state === 'planned' ? 'Suunnitteilla' : 'Toteutettu'}
                  size="small"
                  color={STATE_COLORS[request.state]}
                />
              )}
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
              {request.description}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            sx={{ ml: 2, minWidth: 80 }}
          >
            <Box display="flex" alignItems="center" mb={1}>
              {hasVoted ? (
                <ThumbUpIcon color="primary" />
              ) : (
                <ThumbUpOutlinedIcon color="action" />
              )}
              <Typography variant="h5" sx={{ ml: 1 }}>
                {request.voteCount || 0}
              </Typography>
            </Box>
            {!votingDisabled && (
              <Box display="flex" alignItems="center">
                <Tooltip
                  title={
                    isVoting
                      ? 'Äänestys käynnissä...'
                      : remainingVotes === 0
                      ? 'Ei ääniä jäljellä'
                      : currentVotes >= 3
                      ? 'Max 3 ääntä/toive'
                      : 'Lisää ääni'
                  }
                >
                  <span>
                    <IconButton
                      size="small"
                      onClick={handleAddVote}
                      disabled={isVoting || remainingVotes === 0 || currentVotes >= 3}
                      color="primary"
                    >
                      {isVoting ? <CircularProgress size={20} /> : <AddIcon />}
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            )}
            {hasVoted && (
              <Typography variant="caption" color="primary">
                Äänestit {currentVotes}
              </Typography>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default FeatureRequestCard
